<template>
	<div class="loading">
		<div class="loader"></div>
	</div>
</template>